var React = require('react');

function Ident (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M9.42086 15.0819C5.53597 21.6747 0 25 0 25C0 25 5.79496 21.9773 13.5 21.9773C21.5611 21.9773 27 25 27 25C27 25 22.0253 21.9773 17.6115 15.0819C14.0417 9.50496 13.5958 2.24279 13.5402 0.425994C13.5399 0.148858 13.5324 0 13.5324 0C13.5324 0 13.5318 0.150305 13.5402 0.425994C13.5422 2.11104 13.2767 8.5384 9.42086 15.0819ZM7.28417 20.8753C7.28417 20.8753 9.52248 19.0191 11.3205 15.9635C13.3986 12.432 13.5474 9.28841 13.5474 9.28841C13.5474 9.28841 13.8563 12.9865 15.7592 15.9635C17.8021 19.1594 19.7806 20.8753 19.7806 20.8753C19.7806 20.8753 17.2633 19.7733 13.5324 19.7733C9.96625 19.7733 7.28417 20.8753 7.28417 20.8753Z","fill":"#BEA169"}));
}

Ident.defaultProps = {"width":"42","height":"40","viewBox":"0 0 27 25","fill":"none"};

module.exports = Ident;

Ident.default = Ident;
